// Typesense collection/index names for search

export enum Collections {
    // Core collections
    JOBS = 'jobs',
    ORGS = 'orgs',
    MENTORS = 'mentors',
    PROJECTS = 'projects',
    SKILLS = 'skills',
    VOLUNTEERS = 'volunteers',
    BLOGS = 'blogs',
    SEARCHABLE_PAGES_DATA = 'searchable_pages_data',

    // Community collections
    COMMUNITY_MEMBERS = 'community_members',
    TALENTBASE_MEMBERS = 'talentbase_members',
    USERS = 'users',

    // Published + unlisted indices
    TAGS_PUBLISHED_UNLISTED = 'tags_published_unlisted',
    JOBS_PUBLISHED_UNLISTED = 'jobs_published_unlisted',
    MENTORS_PUBLISHED_UNLISTED = 'mentors_published_unlisted',
    PROJECTS_PUBLISHED_UNLISTED = 'projects_published_unlisted',
    SKILLS_PUBLISHED_UNLISTED = 'skills_published_unlisted',
    VOLUNTEERS_PUBLISHED_UNLISTED = 'volunteers_published_unlisted',

    // Merged
    MERGED_OPPORTUNITIES = 'merged_opportunities'
}
